import axios from 'axios'
import { createI18n, LocaleMessages, VueMessageType } from 'vue-i18n'
import router from '@/router'

axios.defaults.withCredentials = false

const loadedLanguages: string[] = []
const supportedLangs = ['zh-hant']
const dateTimeFormats = {
  'en-us': {
    short: { year: 'numeric', month: 'short', day: 'numeric' },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  'zh-hant': {
    short: { year: 'numeric', month: 'short', day: 'numeric' },
    long: {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  'zh-hans': {
    short: { year: 'numeric', month: 'short', day: 'numeric' },
    long: {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    },
  },
}

const loadLocalMessages = (): LocaleMessages<VueMessageType> => {
  const locales = require.context(
    '../locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages: LocaleMessages<VueMessageType> = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const loadLanguageAsync = async (lang: string, key: string, config: any): Promise<any> => {
  if (loadedLanguages.indexOf(lang) < 0) {
    try {
      return await axios.get(config.VUE_APP_HOST_BACKEND_URL.concat(`api/crm/Locale/Get/${key}/${lang}`))
    } catch (e) {
      return Promise.resolve()
    }
  } else {
    return Promise.resolve()
  }
}

const handleLocalization = async (to: any, config: any): Promise<any> => {
  const key = to.query.key || to.name
  const lang = setLanguage(to)
  i18n.global.locale = lang
  const currMsg: any = i18n.global.getLocaleMessage(lang)

  if (!currMsg[key]) {
    await loadLanguageAsync(lang, key, config).then((response) => {
      if (response && response.data) {
        for (const k in response.data) {
          if (k) {
            currMsg[k] = response.data[k]
          }
        }
      }
      i18n.global.setLocaleMessage(lang, currMsg)
    })
  }
  return lang
}

const setLanguage = (to: any): string => {
  let lang = to.params.lang
  if (!lang || supportedLangs.indexOf(to.params.lang) < 0) {
    lang = 'zh-hant'
  }
  return lang
}

const setupLocaleMsg = (config: any): void => {
  router.beforeEach(async (to: any, from: any, next: any) => {
    const lang = await handleLocalization(to, config)
    if(!supportedLangs.includes(to.params.lang)) {
      to.fullPath = `/${lang}/home`
      next(to.fullPath)
    }
    next()
  })
}

const i18n = createI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'zh-hant',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'zh-hant',
  silentTranslationWarn: true, // process.env.NODE_ENV === 'production',
  dateTimeFormats,
  globalInjection: true,
  messages: loadLocalMessages() as any,
})

export { supportedLangs, i18n, setupLocaleMsg }
